import Highcharts from "./customHighCharts";

export const mapChartConfig = (data, options = {}) => {
  Highcharts.setOptions({ lang: { resetZoom: options.resetZoomLabel } });

  const points = data.locations.map(({ label, latitude, longitude }) => ({
    name: label,
    lat: latitude,
    lon: longitude
  }));

  const zones = buildClusterSizesFor(points.length);

  return {
    chart: {
      margin: 0
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: "bottom"
      }
    },
    tooltip: {
      headerFormat: "",
      pointFormat: "{point.name}"
    },
    colorAxis: {
      min: 0,
      max: 20
    },
    plotOptions: {
      // This configures the markercluster Highcharts' module
      mappoint: {
        cluster: {
          enabled: false, // TODO : fix this
          allowOverlap: false,
          animation: {
            duration: 450
          },
          layoutAlgorithm: {
            type: "grid",
            gridSize: 70
          },
          // Define marker cluster sizes depending on its contained points quantity
          zones
        },
        tooltip: {
          clusterFormat: `${options.clusterLabel} : {point.clusterPointsAmount}`
        }
      }
    },
    series: [
      {
        type: "tiledwebmap",
        name: "Basemap Tiles",
        provider: {
          type: "OpenStreetMap"
        },
        showInLegend: false
      },
      {
        type: "mappoint",
        enableMouseTracking: true,
        colorKey: "clusterPointsAmount",
        data: points,
        dataLabels: {
          // Setting the series' dataLabels configuration as enabled, but leaving the
          // format string empty allows the markercluster module to display the number
          // of markers inside the cluster, but doesn't show the address field for each
          // point on the map, which can be really messy when many points are
          // positionned next to each other
          enabled: true,
          format: ""
        }
      }
    ]
  };
};

const mapChart = (element, data, options) => {
  Highcharts.mapChart(element, mapChartConfig(data, options));
};

const CLUSTER_SIZES_SETTINGS = [
  [0, 0.05, 13],
  [0.05, 0.1, 15],
  [0.1, 0.2, 17],
  [0.2, 0.3, 19],
  [0.3, 1, 21]
];

// This builds an array of cluster "zones" that map the number of points that are
// clustered together, to a certains map cluster circle radius size, which depends on the
// total number of points on the map.
//
const buildClusterSizesFor = pointsCount => {
  // If there's less than 10 points, don't size anything as there won't be many clusters
  // or the clusters will all be approximately the same size.
  if (pointsCount < 10) return [];

  return CLUSTER_SIZES_SETTINGS.map(([fromRatio, toRatio, radius]) => {
    const from = Math.floor(fromRatio * pointsCount + 1);
    const to = Math.max(Math.floor(toRatio * pointsCount), from);

    return { from, to, marker: { radius } };
  });
};

export default mapChart;
